import React, { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import '../styles/HistoricalStats.css';

// Register necessary Chart.js components
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const BusyHoursChart = ({ data }) => {

  const chartData = useMemo(() => {
    // const maxValue = Math.max(...data.map(d => d.value));

    return {
      labels: data.map(({ label }) => label),
      datasets: [{
        label: 'Busy Hours',
        data: data.map(({ value }) => value),
        backgroundColor: '#729CEF',
        borderColor: '#fff',
        borderWidth: 1,
        borderRadius: 25,
        maxBarThickness: 25,
      }],
    };
  }, [data]);


  const options = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        categoryPercentage: 0.4,
        barPercentage: 0.3,
        grid: {
          display: false,
          drawBorder: false,
        },
      },
      y: {
        beginAtZero: true,
        grid: {
          display: true,
          drawBorder: true,
        },
        title: {
          display: true,
          text: 'No of Calls →',
          font: {
            size: 14,
            weight: 'bold',
          },
        },
      },
    },
  }), []);

  return <Bar data={chartData} options={options} />;
};

export default BusyHoursChart;